(function () {
  function getContainer() {
    return document.getElementById('CartDynamicUpsell');
  }

  function escapeHtml(value) {
    var str = value == null ? '' : String(value);
    return str.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return amount.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return amount.toFixed(2) + ' €';
    }
  }

  function imageSrc(url) {
    if (!url) return '';
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  function hasPubSub() {
    return typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function' && typeof subscribe === 'function';
  }

  function productCardHTML(product, addLabel) {
    var variant = product.variants && product.variants[0];
    if (!variant) return '';
    var image = imageSrc((product.images && product.images[0]) || '');
    var priceCents = product.price_varies ? product.price_min : product.price;
    var priceHtml = '<span class="price price--end">' + escapeHtml(formatMoney(priceCents)) + '</span>';
    return (
      '<div class="cart-upsell cart-dynamic-upsell__item" data-product-id="' + product.id + '">' +
        '<div class="cart-upsell__image">' +
          '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="100%" height="auto" class="cart-upsell__image__img">' +
        '</div>' +
        '<div class="cart-upsell__content">' +
          '<a href="' + product.url + '" class="cart-upsell__title h4 break">' + escapeHtml(product.title) + '</a>' +
          '<div class="cart-upsell__prices-and-btn">' +
            priceHtml +
            '<button type="button" class="cart-upsell__btn cart-dynamic-upsell__add" data-variant-id="' + variant.id + '">' +
              escapeHtml(addLabel) +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function attachAddHandlers() {
    var container = getContainer();
    if (!container) return;
    var addUrl = container.dataset.addUrl;
    var buttons = container.querySelectorAll('.cart-dynamic-upsell__add');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = '...';
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] }),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function () {
            if (hasPubSub()) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-dynamic-upsell' });
            } else {
              update();
            }
          })
          .catch(function (err) {
            console.error('cart-dynamic-upsell add error', err);
            btn.disabled = false;
            btn.textContent = originalText;
          });
      });
    });
  }

  function renderProducts(products) {
    var container = getContainer();
    if (!container) return;
    if (!products || products.length === 0) {
      container.innerHTML = '';
      return;
    }
    var heading = container.dataset.heading || 'También te puede interesar';
    var addLabel = container.dataset.addLabel || 'Añadir';
    container.innerHTML =
      '<div class="cart-upsell-container cart-dynamic-upsell__wrapper">' +
        '<h3 class="title h3 center">' + escapeHtml(heading) + '</h3>' +
        '<div class="cart-dynamic-upsell__grid">' +
          products.map(function (p) {
            return productCardHTML(p, addLabel);
          }).join('') +
        '</div>' +
      '</div>';
    attachAddHandlers();
  }

  function fetchRecommendations(baseUrl, productId, intent, limit) {
    var url = baseUrl + '?product_id=' + productId + '&limit=' + limit + '&intent=' + intent;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations request failed');
        return res.json();
      })
      .then(function (data) {
        return (data && data.products) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function update() {
    var container = getContainer();
    if (!container) return;
    var cartUrl = container.dataset.cartUrl;
    var recommendationsUrl = container.dataset.recommendationsUrl;

    fetch(cartUrl + '.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          container.innerHTML = '';
          return;
        }
        var cartProductIds = cart.items.map(function (item) {
          return item.product_id;
        });
        var referenceProductId = cart.items[cart.items.length - 1].product_id;

        fetchRecommendations(recommendationsUrl, referenceProductId, 'complementary', 4).then(function (complementary) {
          var results = complementary.filter(function (p) {
            return p.available && cartProductIds.indexOf(p.id) === -1;
          });
          if (results.length >= 2) {
            renderProducts(results.slice(0, 2));
            return;
          }
          fetchRecommendations(recommendationsUrl, referenceProductId, 'related', 6).then(function (related) {
            var extra = related.filter(function (p) {
              return (
                p.available &&
                cartProductIds.indexOf(p.id) === -1 &&
                results.every(function (r) {
                  return r.id !== p.id;
                })
              );
            });
            var merged = results.concat(extra).slice(0, 2);
            renderProducts(merged);
          });
        });
      })
      .catch(function (err) {
        console.error('cart-dynamic-upsell fetch cart error', err);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!getContainer()) return;
    update();
    if (hasPubSub()) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        update();
      });
    }
  });
})();
